 <template>
 <b-navbar toggleable="lg" class="border-bottom pb-0 mb-0 mt-0 pt-0" type="dark" variant="info">
       <b-navbar-brand class="d-block d-md-none d-lg-none" href="#"><router-link class="link" to="/"><img class="logo" :src="'https://admin.promagic.hu/api/uploads/'+companyData.logo_src"></router-link></b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"><b-icon-list></b-icon-list></b-navbar-toggle>
    <b-collapse id="nav-collapse" class="container" is-nav>
      <b-navbar-nav>
        <b-nav-item class="pl-2 pr-2 border-left-own d-none d-lg-block d-md-block" href="#"><router-link class="link" to="/"><img class="logo" :src="'https://admin.promagic.hu/api/uploads/'+companyData.logo_src"></router-link></b-nav-item>
        <b-nav-item-dropdown class="pl-2 pr-2 border-left-own" text="Árajnálat kérés" left>
          <b-dropdown-item v-for="item in templateData" :key="item.sablon_id"><router-link class="link" @click="reloadPage()" :to="'/template/'+item.sablon_id">{{item.sablon_nev}}</router-link></b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item class="pl-2 pr-2 border-left-own"><router-link class="link" style="color:black" to="/">Árajánlatok</router-link></b-nav-item>
        <b-nav-item class="pl-2 pr-2 border-left-own"><router-link class="link" style="color:black" to="/deliveryNotes">Szállítólevelek</router-link></b-nav-item>
        <b-nav-item class="pl-2 pr-2 border-left-own" v-b-modal.modal-1>Beállítások</b-nav-item>
        <b-nav-item class="pl-2 pr-2 border-left-own border-right-own" @click="logout">Kijelentkezés</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import axios from 'axios'
import router from "../router"
export default {

  name: 'login',
  data() {
      return {
          companyData:[

          ],
          templateData:[
            
          ],
      }
    },
    computed: {
      
    },
    methods: {
		goToTemplates(id){
      router.push({ name: 'Template', params: { id: id }})
      //router.go(0)
		},
        logout(){
            this.$session.remove('id')
            router.push({ path: `/login` })
        },
        getCompanyData(){
            const params = new URLSearchParams();
            params.append('getCompanyData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                this.companyData = response.data[0]
            })
		},
		getTemplateData(){
            const params = new URLSearchParams();
            params.append('getAllTemplate', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_TEMPLATE_API,
                data:params
            }).then((response) => {
        this.templateData = response.data
        console.log(this.templateData);
            })
        }
    },
    mounted(){
		this.getCompanyData();
		this.getTemplateData();
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border-left-own{
  border-left: 1px solid #dee2e6;
}
.border-right-own{
  border-right: 1px solid #dee2e6;
}
@media only screen and (max-width : 550px) {
  .border-left-own{
    border-left: none !important;
  }
  .border-right-own{
    border-right: none !important;
  }
}
</style>